import { gql } from "@apollo/client";
import axios from "axios";
import { BASE_URL } from "../config/api_collection";
import apolloClient from "../graphql";
import { getHeaderData } from "./crm";
import { NudgesAPIRequest } from "../global";

const PROMO_CODE_API = `${BASE_URL}/api/ibe/booking/promotion`;

// The below function will be soon deprecated.
export async function getPromoCode(promoCode: any) {
  const promoQuery = gql`query {
        promotionValidate(promotionCode: "${promoCode}")
    }`;

  const response = await apolloClient.query({
    query: promoQuery,
    variables: {},
    fetchPolicy: "network-only"
  });

  return response;
}

export async function validatePromoCodeAPI(params: any) {
  try {
    const headers = await getHeaderData();
    const apiUrl = `${PROMO_CODE_API}/validate`;
    const parameterForAPI = {
      ...params,
      channel: "WEB"
    };

    const apiResponse = await axios.post(apiUrl, parameterForAPI, { headers });
    const response = {
      status: true,
      errorMessage: "",
      successMessage: ""
    };

    if (apiResponse.data) {
      response.status = apiResponse?.data?.data;
    } else {
      response.status = false;
      response.errorMessage = apiResponse.error.message;
    }
    return response;
  } catch (error: any) {
    console.warn("Error in validating Promo code api", error);
    const response = {
      status: false,
      errorMessage: error?.response?.data?.error?.message,
      successMessage: ""
    };
    return response;
  }
}

export async function applyPromoCodeAPI(params: any) {
  try {
    const headers = await getHeaderData();
    const apiUrl = `${PROMO_CODE_API}/apply`;
    const parameterForAPI = {
      ...params,
      channel: "WEB"
    };

    const apiResponse = await axios.post(apiUrl, parameterForAPI, { headers });
    const response = {
      status: true,
      errorMessage: "",
      successMessage: ""
    };
    // return response; // for testing purpose
    if (apiResponse.data) {
      response.successMessage = apiResponse?.data?.data?.message;
    } else {
      response.status = false;
      response.errorMessage = apiResponse.error.message;
    }
    return response;
  } catch (error: any) {
    console.warn("Error in validating Promo code api", error);
    return {
      status: false,
      errorMessage: error?.response?.data?.error?.message
    };
  }
}

export async function removePromoCodeAPI(params: any) {
  try {
    const headers = await getHeaderData();
    const apiUrl = `${PROMO_CODE_API}`;
    const apiResponse = await axios.delete(apiUrl, { headers });
    const response = {
      status: true,
      errorMessage: "",
      successMessage: ""
    };
    if (apiResponse.data) {
      response.status = apiResponse.data;
    } else {
      response.status = false;
      response.errorMessage = apiResponse?.error?.message;
    }
    return response;
  } catch (error: any) {
    console.warn("Error in validating Promo code api", error);
    return {
      status: false,
      errorMessage: error?.response?.data?.error?.message
    };
  }
}

export async function getActivePromoCodesAndOffers() {
  try {
    const headers = await getHeaderData();
    const apiUrl = `${PROMO_CODE_API}`;
    const params: URLSearchParams = new URLSearchParams({
      channel: "WEB"
    });
    const url = `${apiUrl}?${params.toString()}`;
    const apiResponse = await axios.get(url, { headers });
    return apiResponse?.data?.data;
  } catch (error: any) {
    console.warn("Error in validating Promo code api", error);
    return {
      status: false,
      errorMessage: error?.response?.data?.error?.message
    };
  }
}

export async function getPromoCodeNudgesAPI(nudgesRequest: NudgesAPIRequest) {
  try {
    const headers = await getHeaderData();
    const apiUrl = `${PROMO_CODE_API}/nudges`;
    const parameterForAPI: URLSearchParams = new URLSearchParams({
      currency: nudgesRequest?.currency || '',
      origin: nudgesRequest?.origin || '',
      destination: nudgesRequest?.destination || '',
      departureDate: nudgesRequest?.departureDate || '',
      returnDate: nudgesRequest?.returnDate || '',
      passengerCount: nudgesRequest?.passengerCount || '',
      channel: nudgesRequest?.channel || ''
    })
    const url = `${apiUrl}?${parameterForAPI.toString()}`;
    const response = await axios.get(url, { headers });
    return response?.data;
  } catch (error: any) {
    console.warn("Error in validating Promo code api", error);
    return {
      status: false,
      errorMessage: error?.response?.data?.error?.message
    };
  }
}